var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useMemo } from 'react';
import { useRouter } from 'next/router';
import { QueryParamProvider as ContextProvider } from 'use-query-params';
export const QueryParamProviderComponent = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const router = useRouter();
    const match = router.asPath.match(/[^?]+/);
    const pathname = match ? match[0] : router.asPath;
    const location = useMemo(() => process.browser
        ? window.location
        : {
            search: router.asPath.replace(/[^?]+/u, ''),
        }, [router.asPath]);
    const history = useMemo(() => ({
        push: ({ search }) => router.push({ pathname: router.pathname, query: router.query }, { search, pathname }, { shallow: true }),
        replace: ({ search }) => {
            router.replace({ pathname: router.pathname, query: router.query }, { search, pathname }, { shallow: true });
        },
        location,
    }), [pathname, router.pathname, router.query, location.pathname]);
    return (React.createElement(ContextProvider, Object.assign({}, rest, { history: history, location: location }), children));
};
export const QueryParamProvider = memo(QueryParamProviderComponent);
